import React, { useState, useReducer, useRef, useEffect, useImperativeHandle, forwardRef } from "react";
import { useDispatch } from "react-redux";
import { clearDeviceLogs, GenerateLockOTP } from "../../../../../Api Methods/Api";
import Input from "../../../../CustomDropDown/Input/Input";
import Button1 from "../../../Button/Button1";

import classes from "./GenerateLockOnTimePassCodeForm.module.css"
import TimeDatePicker from "../../../TimeDatePicker/TimeDatePickerOld";
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel'
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { SelectButton } from "primereact/selectbutton";


const NameReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}

const SurnameReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}


const GenerateLockOnTimePassCodeForm = ({ SmartLock, GenerateOTP }) => {

    const [formIsValid, setFormIsValid] = useState(false);

    // const [startDate, setStartDate] = useState(null)

    const [error, setError] = useState('');

    // const [endDate, setEndDate] = useState(null)

    const [nameState, dispatchName] = useReducer(NameReducer, {
        value: '',
        isValid: null
    });

    const [surnameState, dispatchSurname] = useReducer(SurnameReducer, {
        value: '',
        isValid: null
    });

    const NameInputRef = useRef();
    const SurnameInputRef = useRef();

    const { isValid: NameIsValid } = nameState;
    const { isValid: SurnameIsValid } = nameState;

    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [pincodeType, setPincodeType] = useState(-1)
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    

    const selectStartDate = (time, date) => {
        const newDate = date.startDate !== undefined ? date.startDate : date
        const formattedDateTime = `${newDate} ${time}:00`;
        setStartDate(formattedDateTime)
    };

    const selectEndDate = (time, date) => {
        const newDate = date.startDate !== undefined ? date.startDate : date
        const formattedDateTime = `${newDate} ${time}:00`;
        setEndDate(formattedDateTime)
    };

    useEffect(() => {
        if (startDate && endDate) {
            if (new Date(startDate) > new Date(endDate)) {
                setErrorMessage('Start date cannot be after the end date.');
            } 
            // else if (pincodeType == 3 ){
            //     const start = new Date(startDate);
            //     const end = new Date(endDate);

            //     console.log(start)
            //     console.log(end)

            //     const startTime = String(start).split("T")[1]
            //     const endTime = String(end).split("T")[1]

            //     const diffMs = end - start;
            //     const diffDays = diffMs / (1000 * 60 * 60 * 24);

            //     if (diffDays > 28 && (startTime != endTime)) {
            //         setErrorMessage("If duration codes are longer than 28 days, start & end time must be the same");
            //         return;
            //     } else {
            //         setErrorMessage("");
            //         return;
            //     }
            // } 
            else {
                setErrorMessage('');
            }
        }
    }, [startDate, endDate]);

    const convertToUTC = (dateString) => {
        if (dateString != null && dateString !== "") {
            const localDate = new Date(dateString);
    
            const utcYear = localDate.getUTCFullYear();
            const utcMonth = localDate.getUTCMonth(); // 0-based
            const utcDate = localDate.getUTCDate();
            const utcHours = localDate.getUTCHours();
            const utcMinutes = localDate.getUTCMinutes();
    
            const utcDateFlattened = new Date(Date.UTC(utcYear, utcMonth, utcDate, utcHours, utcMinutes));
    
            const formattedUTCDateString = utcDateFlattened
                .toISOString()
                .replace('T', ' ')
                .replace('Z', '');
    
            return formattedUTCDateString;
        }
    };
    

    const getButtonStyle = (option) => ({
        width: '250px',
        color: pincodeType === option ? '#4ba4e3' : '#bfbfbf',
        borderColor: pincodeType === option ? '#4ba4e3' : '#bfbfbf',
    });

    const GeneratePasscode = async () => {
        if (firstName == ""){
            setErrorMessage("Please provide a first name for the user")
            return;
        }

        if (lastName == ""){
            setErrorMessage("Please provide a last name for the user")
            return;
        }

        if (pincodeType == -1){
            setErrorMessage("Please select a pincode type")
            return;
        }

        if (startDate == "") {
            setErrorMessage("Please select a start date & time")
            return;
        }

        if (pincodeType == 3 && startDate == endDate){
            setErrorMessage("End date & time cannot be the same as start date & time")
            return;
        }

        // if (pincodeType === 3) {
        //     const start = new Date(startDate);
        //     const end = new Date(endDate);

        //     const diffMs = end - start;
        //     const diffDays = diffMs / (1000 * 60 * 60 * 24);

        //     if (diffDays > 50) {
        //         setErrorMessage("Duration codes have a maximum length of 50 days");
        //         return;
        //     }
        // }
        const now = new Date().toISOString();
        // if (startDate < convertToUTC(now) ){
        //     console.log("here")
        //     setErrorMessage("Start date cannot be in the past")
        //     return;
        // }

        const pincodeName = `${firstName} ${lastName}`
        if (pincodeType == 1 || pincodeType == 2){
            setEndDate(startDate)
        }
        GenerateOTP(pincodeName, convertToUTC(startDate), convertToUTC(endDate), pincodeType, SmartLock.lockID);
        return;
    }

    const HandleClearSelections = () => {
        setFirstName("")
        setLastName("")
        setPincodeType(-1)
    }

    return (
        <form className={classes["container"]} method="dialog" >
            {errorMessage && (
                <p style={{ fontWeight: "500", fontSize: "14px", color: "#e31414", margin: "0 0 12px 0" }}>{errorMessage}</p>
            )}

            <p style={{ fontWeight: "600", color: "#6e6e6e", margin: "0 0 5px 0", fontSize: "14px" }}>Name of PIN code user</p>

            <div className={classes.nameBoxContainer}>
                <InputText placeholder="First name" id="firstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                <InputText placeholder="Last name" id="lastName" value={lastName} onChange={(e) => setLastName(e.target.value)} />
            </div>

            <p style={{ fontWeight: "600", color: "#6e6e6e", margin: "0 0 5px 0", fontSize: "14px" }}>Use PIN code</p>

            <SelectButton
                className={classes.selectBtns}
                value={pincodeType}
                options={[
                    { label: 'Once', value: 1 },
                    { label: 'Duration', value: 3 },
                    { label: 'Permanent', value: 2 }
                ]}
                onChange={(e) => setPincodeType(e.value)}
            />

            <div className={classes["timeDatePicker-Container"]}>
                <TimeDatePicker handler={selectStartDate} label={"Starts"} />
                {pincodeType === 3 && <TimeDatePicker handler={selectEndDate} label={"Ends"} />}
            </div>

            {pincodeType === 3 && (
                <p style={{ fontWeight: "500", fontSize: "13px", color: "#d97706", margin: "12px 0" }}>Note: Duration codes have a maximum length of 50 days</p>
            )}
            {(pincodeType === 1 || pincodeType === 2) && (
                <p style={{ fontWeight: "500", fontSize: "13px", color: "#6e6e6e", margin: "12px 0" }}>Pincode has a 24 hour activation window. Use within 24 hours of the start date</p>
            )}
            <p style={{ fontWeight: "500", fontSize: "13px", color: "#939393", margin: "8px 0 16px 0" }}>Passcodes can only be deleted using the mobile app & must be within Bluetooth range</p>

            <Button icon="pi pi-check" type="button" label="Generate" className={classes.generateBtn} onClick={GeneratePasscode} />
            <Button icon="pi pi-times" type="button" label="Clear selections" className={classes.clearBtn} onClick={HandleClearSelections} />

        </form>
    )
}

export default GenerateLockOnTimePassCodeForm